module.exports = __webpack_public_path__ + "img/mesa_el_h.cc047231.png";